'use client';

import Link from 'next/link';
import { getPlatformBridge } from '@/logic/bridges';

type StateGcbLogoProps = {
    isXsell: boolean;
    isAndroid: boolean;
    url: string;
    target: string;
    logoUrl: string;
};

export const StateGcbLogo = ({ isXsell, isAndroid, url, target, logoUrl }: StateGcbLogoProps) => {
    const handleLogoClick = (e: React.MouseEvent<HTMLAnchorElement>, targetUrl?: string) => {
        if (!targetUrl || (!isXsell && !isAndroid)) {
            return;
        }

        e.preventDefault();
        e.stopPropagation();

        const bridge = getPlatformBridge();
        bridge.exec('openExternalWebView', targetUrl);
        bridge.exec('redirectToBrowser', targetUrl);
    };

    return (
        <Link
            href={url}
            target={target}
            rel="external"
            className="footer-legal__state-gcb-logo-link"
            onClick={(e) => handleLogoClick(e, url)}>
            <img src={logoUrl} data-test-id="footer-state-gcb-logo" alt="gcb" height={40} width="auto" />
        </Link>
    );
};
